/**
 * patrol-evidence-search-view.js
 */

import React from 'react';
import { parseISO, format, intervalToDuration, formatDuration } from 'date-fns';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolEvidenceSearchView(props) {
  const { record, patrolTypes } = props;
  const evidenceSearch = record.evidenceSearch;
  const searchItems = evidenceSearch.items.filter(item => Boolean(item.id)).map(item => item.name);

  const evidenceSearchInterval = evidenceSearch?.startTime && evidenceSearch?.endTime 
    ? intervalToDuration({ start: parseISO(evidenceSearch.startTime), end: parseISO(evidenceSearch.endTime) })
    : null;
  const evidenceSearchDuration = evidenceSearchInterval 
    ? formatDuration(evidenceSearchInterval, {format: ['hours', 'minutes']})
    : null;

  return (
    <>
      {record &&
      <IconSection iconName='patrol-evidence-search'>
        <PatrolTypeTitle 
          patrolType={record.type} 
          patrolTypes={patrolTypes} 
          step={record.order}
        />
        
        <InfoRow title='Monitor' text={evidenceSearch.monitor} />
        <InfoRow title='Controlled Negative' text={evidenceSearch.isControlledNegative ? 'Yes' : 'No'} />
        {searchItems?.length > 0 &&
        <InfoRow title='Search Items' text={searchItems?.join(', ')} />}
        <InfoRow title='Terrain Types' text={evidenceSearch.types.map(type => type.customOtherName || type.name).join(', ')} />
        {evidenceSearch.areaSize &&
        <InfoRow title='Area Size' text={`${evidenceSearch.areaSize} ${evidenceSearch.areaSizeUnit?.name}`} />}
        {evidenceSearch.startTime &&
        <InfoRow title='Search Time'
          text={`${format(parseISO(evidenceSearch.startTime), 'h:mm aaa')}` +
                `${evidenceSearch.endTime ? ' - ' + format(parseISO(evidenceSearch.endTime), 'h:mm aaa') : ''}` +
                `${evidenceSearchDuration ? ' (' + evidenceSearchDuration + ')' : ''}`
                }
          />}
      </IconSection>}
    </>
  );
}